
import { ChallengeData } from "@/models/Base/ChallengeData";
import { Component, Vue, Prop } from "vue-property-decorator";
import ImageBox from "./ImageBox.vue";
import ImageSelector from "./ImageSelector.vue";
import { Validations } from "vuelidate-property-decorators";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

@Component({
  components: {
    ImageBox,
    ImageSelector,
  },
})
class ChallengeBox extends Vue {
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: null }) readonly content!: ChallengeData;
  @Prop({ default: "" }) readonly title!: string;
  @Prop({ default: "Header Image" }) readonly imageHeader!: string;
  @Prop({ default: "Enter display values" }) readonly placeholderText!: string;
  @Prop({ default: "" }) readonly questionTitle!: string;
  @Prop({ default: "" }) readonly imagePath!: string;
  @Prop({ default: "" }) readonly audioPath!: string;
  @Prop({ default: "" }) readonly videoPath!: string;
  @Prop({ default: 160 }) readonly maxQuestionLength!: number;

  showImageSelectorBool = false;
  isAudio = false;
  isVideo = false;

  get getMaxLength(): number {
    return this.maxQuestionLength;
  }

  get getImagePath(): string {
    if (this.isAudio) {
      return this.audioPath;
    } else if (this.isVideo) {
      return this.videoPath;
    } else {
      return this.imagePath;
    }
  }

  get getHeadingVideo(): string {
    if (this.content.audio !== undefined && this.content.audio?.en.length > 0)
      return "Video cannot be used whilst audio is specified";
    return "";
  }
  get getHeadingAudio(): string {
    if (this.content.video !== undefined && this.content.video?.en.length > 0)
      return "Audio cannot be used whilst video is specified";
    return "";
  }

  get getImage(): string {
    return this.content.image;
  }

  showImageSelector(): void {
    if (!this.isEditingLocked) {
      this.isAudio = false;
      this.isVideo = false;
      this.showImageSelectorBool = true;
    }
  }

  removeVideoData(): void {
    if (!this.isEditingLocked) {
      this.content.video = { en: "" };
      this.onDataChange();
    }
  }
  removeAudioData(): void {
    if (!this.isEditingLocked) {
      this.content.audio = { en: "" };
      this.onDataChange();
    }
  }

  showAudioSelector(): void {
    if (!this.isEditingLocked && this.content.video?.en.length == 0) {
      this.isAudio = true;
      this.isVideo = false;
      this.showImageSelectorBool = true;
    }
  }
  showVideoSelector(): void {
    if (!this.isEditingLocked && this.content.audio?.en.length == 0) {
      this.isVideo = true;
      this.isAudio = false;
      this.showImageSelectorBool = true;
    }
  }

  handleCloseButtonPress(): void {
    this.showImageSelectorBool = false;
  }
  returnImagePath(path: string): void {
    if (this.isAudio) {
      this.content.audio = { en: this.getImagePath + "" + path };
      this.onDataChange();
      this.showImageSelectorBool = false;
    } else if (this.isVideo) {
      this.content.video = { en: this.getImagePath + "" + path };
      this.onDataChange();
      this.showImageSelectorBool = false;
    } else {
      this.content.image = this.getImagePath + "" + path;
      this.onDataChange();
      this.showImageSelectorBool = false;
    }
  }

  clearImage(): void {
    if (!this.isEditingLocked) {
      this.content.image = "";
      this.onDataChange();
    }
  }
  onDataChange(): void {
    if (this.content.image == undefined) {
      this.content.image = "";
    }
    if (this.content.audio == undefined) {
      this.content.audio = { en: "" };
    }
    if (this.content.video == undefined) {
      this.content.video = { en: "" };
    }
    this.$emit("onDataChange", this.content);
  }
  @Validations()
  validations = {
    content: {
      text: {
        required,
        minLength: minLength(3),
      },
    },
  };
}

export default ChallengeBox;
